import { createContext } from 'react';
import { FilterChoice } from '../types/FilterChoice';

export const SearchFilterContext = createContext<FilterChoice>({});
